var isBrowser = typeof window !== 'undefined';
var isIframe = isBrowser ? window.self !== window.top : false;
export { isBrowser, isIframe };